import { GetOrdersRequest, Order } from '../../pages/Orders/Orders.interfaces';
import { api } from './api';

interface GetOrdersResponse {
  orders: Order[];
  quantity: number;
}

interface CreateOrderResponse {
  orderId: string;
  number: string;
}

interface GetReportResponse {
  data: string;
  fileName: string;
  extension: string;
}

export const ordersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // получение списка заявок
    getOrders: builder.mutation<GetOrdersResponse, GetOrdersRequest>({
      query: (data) => ({
        url: 'order_list',
        method: 'POST',
        body: data,
        providesTags: ['getOrders'],
      }),
    }),

    // создание заявки
    createOrders: builder.mutation<CreateOrderResponse, Order>({
      query: (data) => ({
        url: 'order_add',
        method: 'POST',
        body: data,
        invalidatesTags: ['getOrders'],
      }),
    }),

    // Запрос на отправку кода подтверждения
    sentVerifyCode: builder.mutation<CreateOrderResponse, { orderId: string }>({
      query: (data) => ({
        url: 'send_verify_code',
        method: 'POST',
        body: data,
      }),
    }),

    // Запрос отчета за период
    getReport: builder.mutation<
      GetReportResponse,
      { dateBeg: string; dateEnd: string }
    >({
      query: (data) => ({
        url: 'report_brokerage_activities',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});
